import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight, Users } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

// Journey 4 langkah: 1 Siapkan → 2 Jalankan harian → 3 Pantau → 4 Selesaikan
export const JOURNEY = {
  students: { step: 1, title: "Siapkan", now: "Daftarkan siswa", next: ["/users", "Guru & kompetensi"] },
  teachers: { step: 1, title: "Siapkan", now: "Daftarkan guru & kompetensinya", next: ["/modules", "Program & Modul"] },
  program: { step: 1, title: "Siapkan", now: "Pastikan modul tiap kelas lengkap", next: ["/setup", "Mulai Rombel"] },
  setup: { step: 1, title: "Siapkan", now: "Bentuk rombel: siswa → guru → tanggal → jadwal otomatis", next: ["/today", "Hari Ini (mulai mengajar)"] },
  today: { step: 2, title: "Jalankan harian", now: "Absensi → nilai → attitude untuk rombel hari ini", next: ["/", "Dashboard (lihat hasil)"] },
  attendance: { step: 2, title: "Jalankan harian", now: "Tandai yang tidak masuk, lalu simpan", next: ["/assessment", "Nilai hari ini"] },
  assessment: { step: 2, title: "Jalankan harian", now: "Isi nilai per modul lalu Close tanggal", next: ["/attitude", "Attitude bila ada kejadian"] },
  attitude: { step: 2, title: "Jalankan harian", now: "Catat plus/minus poin saat ada kejadian", next: ["/today", "Kembali ke Hari Ini"] },
  dashboard: { step: 3, title: "Pantau", now: "Lihat tren nilai, kehadiran, beban guru", next: ["/timeline", "Garis Waktu Kelas"] },
  timeline: { step: 3, title: "Pantau", now: "Cek hari yang tertinggal (merah) dan isi", next: ["/kanban", "Kanban Kelas"] },
  kanban: { step: 3, title: "Pantau", now: "Konfirmasi K·S·A siswa; di akhir siklus klik Naik Kelas", next: ["/reports", "Laporan"] },
  reports: { step: 3, title: "Pantau", now: "Unduh rapor & rekap", next: ["/certificates", "Sertifikat"] },
  certificates: { step: 4, title: "Selesaikan", now: "Terbitkan sertifikat → siswa otomatis jadi Alumni", next: ["/alumni", "Alumni"] },
  alumni: { step: 4, title: "Selesaikan", now: "Alumni siap ditempatkan", next: ["/hearing", "Hearing & Consulting"] },
  dropped: { step: 4, title: "Selesaikan", now: "Siswa yang mundur tercatat di sini", next: ["/kanban", "Kanban Kelas"] },
  hearing: { step: 4, title: "Selesaikan", now: "Pantau alumni di Jepang 36 bulan", next: ["/", "Dashboard"] },
};

export function JourneyHint({ k }) {
  const j = JOURNEY[k];
  if (!j) return null;
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2 rounded-lg border border-sky-100 bg-sky-50/60 px-3 py-2 text-xs text-slate-700 dark:bg-slate-900 dark:border-slate-700" data-testid="journey-hint">
      <span className="grid h-5 w-5 place-items-center rounded-full bg-sky-600 text-[10px] font-bold text-white">{j.step}</span>
      <b>{j.title}</b><span className="text-slate-400">·</span><span>{j.now}</span>
      <a href={j.next[0]} className="ml-auto inline-flex items-center gap-1 font-semibold text-sky-700 hover:underline" data-testid="journey-next">Selanjutnya: {j.next[1]}<ArrowRight className="h-3.5 w-3.5" /></a>
    </div>
  );
}

// Toast "Langkah berikutnya" setelah satu tindakan selesai
export function nextStep(message, to, label) {
  toast.success(message, { description: `Langkah berikutnya: ${label}`, action: { label: "Lanjut", onClick: () => { window.location.href = to; } }, duration: 7000 });
}

// Toggle "Rombel saya": hanya rombel di mana user login punya penugasan mengajar
export function useMyGroups(groups) {
  const { user } = useAuth();
  const isTeacher = ["teacher", "instructor"].includes(user?.role);
  const key = "my_groups_only";
  const stored = localStorage.getItem(key);
  const on = stored == null ? isTeacher : stored === "1";
  const mine = (groups || []).filter((g) => (g.teachers || []).some((x) => x.user_id === user?.id));
  const hasMine = mine.length > 0;
  return { on: on && hasMine, hasMine, isTeacher, list: on && hasMine ? mine : (groups || []), count: mine.length };
}

export function MyGroupsToggle({ state, onChange }) {
  const { hasMine, on, count } = state;
  if (!hasMine) return null;
  return (
    <button type="button" onClick={() => { localStorage.setItem("my_groups_only", on ? "0" : "1"); onChange(); }} className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold transition-colors ${on ? "bg-slate-900 text-white border-transparent" : "bg-white text-slate-600 border-slate-200 hover:border-slate-900"}`} data-testid="my-groups-toggle" title="Tampilkan hanya rombel yang saya ajar">
      <Users className="h-3.5 w-3.5" />{on ? `Rombel saya (${count})` : "Semua rombel"}
    </button>
  );
}

export function useGo() { return useNavigate(); }
